export const JOURNEY_OT_LOAD_STATE = 1;
export const JOURNEY_OT_UNLOAD_STATE = 0;

export const JOURNEY_OT_STATES = {
    [JOURNEY_OT_LOAD_STATE]: "Cargado",
    [JOURNEY_OT_UNLOAD_STATE]: "Descargado"
};

export function getOTStateText(state: number): string {
    return JOURNEY_OT_STATES[state];
}
